module.exports = __webpack_public_path__ + "img/art6-img3.c40324c2.jpeg";